var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.959,
    viewBox: "0 0 18 17.959",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trace_-_2024-05-17T184845.230",
    "data-name": "trace - 2024-05-17T184845.230",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41311",
    "data-name": "Path 41311",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41312",
    "data-name": "Path 41312",
    d: "M1.886.3A1.929,1.929,0,0,0,.586,1.5l-.094.259V16.494l.1.251a1.933,1.933,0,0,0,1.315,1.17c.167.043,1.193.049,7.4.041l7.206-.009.2-.083a1.9,1.9,0,0,0,1.147-1.2c.042-.132.089-.267.105-.3.043-.088.038-14.566-.005-14.539-.019.012-.034-.01-.034-.048a1.53,1.53,0,0,0-.086-.305A2,2,0,0,0,16.753.365l-.24-.1L9.288.263c-6.1-.006-7.253,0-7.4.042m-1.4,8.8c0,4.005,0,5.644.009,3.641s0-5.28,0-7.282S.491,5.1.491,9.108M3.31,2.968c0,.01,1.032,1.539,2.294,3.4s2.3,3.4,2.3,3.419-1.027,1.251-2.285,2.732-2.294,2.706-2.3,2.721a2.074,2.074,0,0,0,.486.028h.5l2.02-2.378c1.111-1.308,2.038-2.378,2.058-2.378s.761,1.066,1.646,2.37l1.608,2.37,1.767.009,1.767.009-.115-.165c-.063-.091-1.148-1.687-2.41-3.548-1.405-2.072-2.285-3.4-2.269-3.425s3.539-4.185,4.206-4.963l.186-.216H13.744L11.82,5.216C10.762,6.462,9.892,7.482,9.887,7.482s-.7-1.019-1.542-2.265L6.811,2.953H5.061c-.963,0-1.751.006-1.751.016m1.372.772c.006.016,1.679,2.444,3.718,5.4L12.106,14.5h.811c.446,0,.811-.009.811-.019s-1.671-2.439-3.712-5.4L6.3,3.711H5.487a5.594,5.594,0,0,0-.805.029",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.1f171f93a5a38751fc93bb0953c957cc.svg";
export { ForwardRef as ReactComponent };